import { useEffect } from 'react'
import { useStaticData } from '@mc/static-data-react'
import { sprigIdentifyAndSetAttributes, sprigTrackEvent } from './utils'

interface UseSprigOptions {
  initialEvents?: Array<{
    name: string
    properties?: Record<string, unknown>
  }>
}

export const useSprig = (options: UseSprigOptions = {}) => {
  const { isLoggedIn } = useStaticData<{ isLoggedIn: boolean }>()

  useEffect(
    () => {
      const initializeSprig = async () => {
        await sprigIdentifyAndSetAttributes({ isLoggedIn })

        if (options.initialEvents) {
          await Promise.all(
            options.initialEvents.map((event) =>
              sprigTrackEvent(event.name, {
                ...event.properties,
              }),
            ),
          )
        }
      }

      initializeSprig()
    },
    // Intentionally only running this effect once when the component mounts.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  return {
    trackEvent: async (
      eventName: string,
      properties?: Record<string, unknown>,
    ) => {
      await sprigTrackEvent(eventName, properties)
    },
  }
}
